import AbstractFortnoxImporter from "./AbstractFortnoxImporter.js";
import FortnoxIntegration from "../../../../models/integration/FortnoxIntegration.js";

/**
 * `FortnoxImporter` Import wizard for the Fortnox integration.
 */
export default class FortnoxImporter extends AbstractFortnoxImporter {
	useFortnoxExtended() {
		return false;
	}

	routeName() {
		return "fortnox";
	}

	hasIntegration() {
		return this._context.company.hasFortnoxIntegration();
	}
}

FortnoxImporter.integrationType = FortnoxIntegration.getType();
